import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

const HeadText = ({ text }) => {
  return (
    <div data-testid="pro_text" className={`${styles.text} ${styles.head3}`}>
      {text}
    </div>
  );
};

HeadText.defaultProps = {
  text: 'Head Text'
};

HeadText.propTypes = {
  text: PropTypes.string
};

export default HeadText;
